import {otto} from "@otto-ec/global-resources/nexus";
import {Logger} from "./logger";
import {TopicpromoCinema} from "./cinema/topicpromo_cinema";

otto.ft3.promo.topicpromo.assignNamespace({
    init
});

function init(): void {
    Logger.group("[FT3 promo topicpromo]");
    Logger.count("Topicpromo Invocation");

    document.querySelectorAll('.promo_topicpromo-cinema--container').forEach((container: Element) => {
        new TopicpromoCinema(container);
    });

    Logger.groupEnd();
}